import React from 'react'
import PropTypes from 'prop-types'
import { DiscussionEmbed, CommentCount } from 'disqus-react';
import { graphql } from 'gatsby'
import SEO from '../../components/PageSEO';
import Layout from '../../containers/layout/layout'
import Heading from '../../components/shared/heading'
import Text from '../../components/shared/text'
import {
    BlogDetailsWrap,
    BlogDetailsHeader,
    BlogDetailsMetaWrap,
    BlogDetailsMeta,
    BlogDetailsContent,
    CommentWrap,
    CommentFormWrap
} from './blog-template.stc'

function BlogTemplate({ data: { blog }, ...restProps }) {
    const { titleStyle, metaBoxStyle, metaHeadingStyle, metaTextStyle } = restProps;
    const disqusShortname = 'furkanacar';
    const disqusConfig = {
        url: blog.path,
        identifier: blog.id,
        title: blog.title,
    };
    return (
        <Layout>
            <SEO title={blog.seo.title}
                description={blog.seo.description}
            />
            <BlogDetailsWrap>
                <BlogDetailsHeader fluid={blog.image.fluid}>
                    <div className="row align-items-center">
                        <div className="col-2 offset-1">
                            <div className="rn-blog-details-meta-inner">
                                <Heading {...titleStyle}>{blog.title}</Heading>
                            </div>
                        </div>
                        <div className="col-1 offset-1">
                            <BlogDetailsMetaWrap>
                                <BlogDetailsMeta {...metaBoxStyle}>
                                    <Text {...metaTextStyle}>Yayın Tarih:</Text>
                                    <Heading {...metaHeadingStyle}>{blog.date}</Heading>
                                </BlogDetailsMeta>
                                <BlogDetailsMeta {...metaBoxStyle}>
                                    <Text {...metaTextStyle}>Yazar:</Text>
                                    <Heading {...metaHeadingStyle}>{blog.author}</Heading>
                                </BlogDetailsMeta>
                                <BlogDetailsMeta {...metaBoxStyle}>
                                    <Text {...metaTextStyle}>Yorumlar:</Text>
                                    <Heading {...metaHeadingStyle}>
                                        <CommentCount shortname={disqusShortname} config={disqusConfig} />
                                    </Heading>
                                </BlogDetailsMeta>
                            </BlogDetailsMetaWrap>
                        </div>
                    </div>
                </BlogDetailsHeader>
                <BlogDetailsContent>
                    <div dangerouslySetInnerHTML={{ __html: blog.contentNode.childMarkdownRemark.html }} />
                </BlogDetailsContent>
                <CommentWrap>
                    <CommentFormWrap>
                        <DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
                    </CommentFormWrap>
                </CommentWrap>
            </BlogDetailsWrap>
        </Layout>
    )
}

export const blogQuery = graphql`
  query($slug: String!) {
    blog: datoCmsBlog(slug: { eq: $slug }) {
      seo {
        description
        title
        image {
          sizes {
            src
          }
        }
      }
      id
      title
      desc
      author
      slug
      image {
        fluid(maxWidth: 1920, maxHeight: 800) {
            ...GatsbyDatoCmsFluid_noBase64
          }
      }
      date(formatString: "Do MMMM, YYYY" locale:"tr")
      contentNode {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`


BlogTemplate.propTypes = {
    metaHeadingStyle: PropTypes.object,
    metaTextStyle: PropTypes.object,
    titleStyle: PropTypes.object
}

BlogTemplate.defaultProps = {
    titleStyle: {
        as: 'h1',
        color: '#fff',
        responsive: {
            small: {
                mb: '22px'
            }
        }
    },
    metaBoxStyle: {
        mb: '30px',
        responsive: {
            small: {
                mb: 0,
                pt: '11px',
                pb: '11px'
            }
        }
    },
    metaHeadingStyle: {
        as: 'h6',
        color: '#fff',
        fontSize: '12px',
        fontweight: 700,
        letterspacing: '2px',
        mb: '12px'
    },
    metaTextStyle: {
        m: 0,
        fontSize: '12px',
        color: '#fff',
        letterspacing: '1px'
    }
}

export default BlogTemplate
